<app-modal [id]="modalId" [maskClose]="false" class="{{ user? 'modal-user-logged-in' : 'modal-user-logged-out' }}">
	<aside class="modal confirm-modal">
		<div class="modal-body">
			<div class="header">
				<div class="button regular close" (click)="cancel()"><span class="icon">&#x00D7;</span></div>
			</div>
			<div class="content">
				<img src="../../../assets/img/promo-stacks-modal/promo-stacks-logo.svg" class="promo-stacks-logo" alt="">
				<h4 class="title">A New Way to Book Promos</h4>
				<p class="description">Schedule an entire promo stack at once! Choose from our ready-made stacks to boost your book sales, save time, and make the Amazon algorithm work for you. Click below to view available promo stacks!</p>
			</div>
			<div class="footer">
				<button class="button regular solid-white" (click)="promosStacks()">Get Started</button>
			</div>
		</div>
	</aside>
	<div class="confirm-modal-background"></div>
</app-modal>
